import { useEffect, useState } from "react";
import { apiGet } from "../../lib/api.js";

export default function DownloadsTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [working, setWorking] = useState("");

  async function load() {
    setLoading(true);
    setErr("");
    try {
      // Backend: GET /api/me/downloads -> { items: [ {orderId, title, sku, createdAt, expiresAt} ] }
      const data = await apiGet("/api/me/downloads");
      setItems(Array.isArray(data.items) ? data.items : []);
    } catch (e) {
      setErr("Não foi possível carregar o histórico de downloads.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);
  async function reemit(ref) {
    try {
      setWorking(ref);
      const r = await apiGet(`/api/download/by-ref/${encodeURIComponent(ref)}`);

      const url =
        r?.downloads?.[0]?.url || r?.url || null;

      if (!url) {
        throw new Error("sem url");
      }

      window.open(url, "_blank", "noopener,noreferrer");
    } catch (e) {
      console.error(e);
      alert("Falha ao reemitir o link (apenas para encomendas pagas).");
    } finally {
      setWorking("");
    }
  }



  if (loading) return <div className="py-3">A carregar…</div>;
  if (err) return <div className="text-danger">{err}</div>;

  return (
    <div className="table-responsive">
      <table className="table align-middle">
        <thead>
          <tr>
            <th>Data</th>
            <th>Encomenda</th>
            <th>Item</th>
            <th>Expira</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {items.map((d) => (
            <tr key={`${d.orderId}-${d.sku}`}>
              <td>{d.createdAt ? new Date(d.createdAt).toLocaleString() : "-"}</td>
              <td><code>{d.orderId}</code></td>
              <td>{d.title || d.sku}</td>
              <td>{d.expiresAt ? new Date(d.expiresAt).toLocaleString() : "-"}</td>
              <td className="text-end">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => reemit(d.orderId)}
                  disabled={!!working}
                >
                  {working === d.orderId ? "A gerar..." : "Reemitir link"}
                </button>
              </td>
            </tr>
          ))}
          {items.length === 0 && (
            <tr><td colSpan={5} className="text-center py-4">Sem registos.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
